export const TOGGLE_STRING_DEBUG = 'dev.toggleStringDebug';
export const TOGGLE_ASSET_STATUS = 'dev.toggleAssetStatus';
